export default __webpack_public_path__ + "images/03133973f9580745312b5baaa37eddc7-bancontact_logo.png";